import * as React from 'react';

import { useApi } from '../context';
import { SearchResult } from '../models';
import { useDebounce, useDealPartnerQuery } from '../hooks';
import { CerebroAutoComplete, CerebroAutoCompleteProps } from '.';

export const DealPartnerAutoComplete: React.FC<DealPartnerAutoCompleteProps> = props => {
	const api = useApi();

	const [inputValue, setInputValue] = React.useState('');

	const search = useDebounce(inputValue, 200);

	const enabled = inputValue != null && inputValue.length >= 3;

	const dealPartnerQuery = useDealPartnerQuery();

	const options = enabled ? dealPartnerQuery.data ?? ([] as SearchResult[]) : ([] as SearchResult[]);

	return (
		<CerebroAutoComplete
			{...props}
			placeholder="Enter Deal Partner Name"
			clearOnEscape
			loading={dealPartnerQuery.isFetching}
			options={options}
			isOptionEqualToValue={(option: SearchResult, value: SearchResult) => option.guid === value.guid}
			getOptionLabel={(partner: SearchResult) => `${partner.name}`}
			onInputChange={(_, newInputValue) => {
				setInputValue(newInputValue);
			}}
		/>
	);
};

type DealPartnerAutoCompleteProps = CerebroAutoCompleteProps<SearchResult, false, false, false>;
